import { del, get, post, URLs } from './request';

export const getMemberships = async () => {
  const { data } = await get({
    url: `${URLs.api}/v2/memberships`,
    options: { CORS_API: true },

  });
  return data;
};

export const getSubscribedMemberships = async () =>
  await get({
    url: `${URLs.user}/subscribed_memberships`,
    options: { CORS_API: true },
  });

export const subscribeToMembership = async ({ id, identifier }) =>
  await post({
    url: `${URLs.api}/subscriptions`,
    options: { CORS_API: true },
    data: {
      membership_id: id,
      stripe_payment_method_id: identifier,
    },
  });
/**
 * Cancel Membership Request
 * @param {number} id Subscription ID
 * @param {{ cancellation_reason:string, additional_text:string }} formData Data from cancellation reason form
 */
export const cancelMembership = async (id, formData) => {
  const { cancellation_reason, additional_text } = formData;
  return await del({
    url: `${URLs.api}/v2/subscriptions/${id}`,
    options: { data: { cancellation_reason, additional_text, }, CORS_API: true },
  });
};

export const getSubsriptions = async (id) => {
  const url = id ? `${URLs.api}/subscriptions/${id}` : `${URLs.api}/subscriptions`;
  return await get({
    url,
    options: { CORS_API: true },
  });
};
